import { Entity } from "../helpers/Entity"

export type GroupAttributes = {
    billingMethod: string
    currency: string
    subtotalAmount: number
    subtotalAmountInclusive: number
    name: string
    description: string
    calendarEventIds: string[]
}

export type GroupDto = {
    id: string
    type: string
    attributes: GroupAttributes
}

export default class Group implements Entity {
    private dto: GroupDto

    constructor(dto: GroupDto) {
        this.dto = dto
    }

    isLoaded() {
        return this.dto.type == "pricing-groups"
    }

    getId() {
        return this.dto.id
    }

    getDto() {
        return this.dto
    }
}


// WEBPACK FOOTER //
// ./src/state/pricing/Group.ts